import { useEffect } from 'preact/hooks';
export const useLoadGiftBox = ({ itemKey , giftboxProducts , setStateRaw , setCart , setGiftBoxId , setLoading  })=>{
    useEffect(()=>{
        (async ()=>{
            try {
                var _parent_properties, _parent_product, _parent_properties1;
                const res = await fetch('/cart.js');
                if (!res.ok) {
                    setLoading(false);
                    return;
                }
                const cart = await res.json();
                setCart(cart);
                const parent = (cart.items || []).find((it)=>it.key === itemKey);
                if (!parent) {
                    setLoading(false);
                    return;
                }
                const parentGiftBoxId = (_parent_properties = parent.properties) === null || _parent_properties === void 0 ? void 0 : _parent_properties._gift_box_id;
                setGiftBoxId(parentGiftBoxId || null);
                const children = (cart.items || []).filter((it)=>{
                    var _it_properties;
                    return ((_it_properties = it.properties) === null || _it_properties === void 0 ? void 0 : _it_properties._gift_box_parent_id) === parentGiftBoxId && it.key !== itemKey;
                });
                // Resolve the giftbox product handle from cart data
                let handle = parent.handle || ((_parent_product = parent.product) === null || _parent_product === void 0 ? void 0 : _parent_product.handle) || '';
                // Also try to match by variant id against giftboxProducts
                if (!handle && giftboxProducts) {
                    for (const [productHandle, prod] of Object.entries(giftboxProducts)){
                        const variants = Array.isArray(prod === null || prod === void 0 ? void 0 : prod.variants) ? prod.variants : [];
                        if (variants.some((v)=>String(v.id) === String(parent.variant_id))) {
                            handle = productHandle;
                            break;
                        }
                    }
                }
                const variant = parent.variant_id ? String(parent.variant_id) : '';
                // Build selected item unit keys matching the format used by select-items step.
                // Children reference items that were originally independent cart lines,
                // so we re-create the `lineKey::unitIndex` keys.
                const selectedItems = children.flatMap((child)=>{
                    const qty = Number(child.quantity) || 1;
                    return Array.from({
                        length: qty
                    }, (_, i)=>`${child.key}::${i}`);
                });
                const giftboxMessage = ((_parent_properties1 = parent.properties) === null || _parent_properties1 === void 0 ? void 0 : _parent_properties1._gift_box_message) || '';
                setStateRaw({
                    giftbox: handle,
                    variant,
                    items: selectedItems,
                    giftboxMessage
                });
            } catch (err) {
                console.error('Failed to load gift box data for editing', err);
            } finally{
                setLoading(false);
            }
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        itemKey
    ]);
};
